import { configureFrontendDAL } from "@frontend/shared/data/frontend-dal";
import { CoreModule } from "@/features/core/core.module";
import { httpClient } from "@frontend/shared/infrastructure/api/http-client";

configureFrontendDAL({
  queryClient: CoreModule.queryClient,
  apiClient: httpClient,
});
